export default "__VITE_ASSET__80f66176__"